import { useState } from 'react';
import ChevronLeftIcon from '@/components/icons/ChevronLeftIcon';
import ChevronRightIcon from '@/components/icons/ChevronRightIcon';

type Props = {
  total?: number;
  page?: number;
  pageSize?: number;
  pageCount?: number;
  onChangePagination: (page: number) => void;
};
export default function JobPagination(props: Props) {
  const [pagePagination, setPagePagination] = useState(props.page);
  const pages = Array.from(
    { length: props.pageCount ?? 0 },
    (_, index) => index + 1
  );
  const handlePreviousClick = () => {
    if (pagePagination && pagePagination > 1) {
      const prePage = pagePagination - 1;

      props.onChangePagination(prePage);
      setPagePagination(prePage);
    }
  };

  const handleNextClick = () => {
    if (!pagePagination || !props.pageCount) return;
    if (pagePagination < props.pageCount) {
      const nextPage = pagePagination + 1;
      props.onChangePagination(nextPage);
      setPagePagination(nextPage);
    }
  };
  if (props.pageCount === 1) return <></>;
  return (
    <div className="flex items-center justify-end bg-white py-3 sm:px-6">
      <div className="desktop:flex-row flex flex-1 flex-col items-center justify-end">
        <nav
          className="shadow-shadow8 isolate inline-flex -space-x-px rounded-[6px]"
          aria-label="Pagination"
        >
          {props.page !== 1 && (
            <button
              className="disabled:text-neutral-15 disabled:bg-neutral-20 hover:bg-neutral-20 relative inline-flex items-center rounded-l-[6px] p-2 text-gray-400 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:cursor-not-allowed"
              onClick={handlePreviousClick}
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          )}
          {pages.map((page, index) => (
            <button
              key={index}
              aria-current="page"
              disabled={page === props.page}
              className={`${
                props.page === page
                  ? 'bg-brand-primary text-white'
                  : 'hover:bg-neutral-20 bg-white text-black'
              }  relative z-10 inline-flex items-center px-4 py-2 text-sm font-semibold
    ${
      props.page === 1 && index === 0
        ? 'rounded-l-[6px]'
        : props.page === props.pageCount && index === pages.length - 1
        ? 'rounded-r-[6px]'
        : ''
    }`}
              onClick={() => {
                props.onChangePagination(page);
              }}
            >
              {page}
            </button>
          ))}
          {props.page !== props.pageCount && (
            <button
              disabled={pagePagination === props.pageCount}
              className="disabled:bg-neutral-20 hover:bg-neutral-20 relative inline-flex items-center rounded-r-[6px] p-2 text-gray-400 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:cursor-not-allowed"
              onClick={handleNextClick}
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          )}
        </nav>
      </div>
    </div>
  );
}
